// Ported from vlookup-dramatic/app/how-it-works/reveal.tsx by scripts/revamp/port-design.js
import { createElement, useEffect, useRef } from "react";
import { cn } from "../../lib/utils";
// Small scroll-reveal wrapper (IntersectionObserver). Pairs with the
// `.hiw-reveal` / `.hiw-in` CSS defined in the page's <style> tag.
// Degrades gracefully: no IO support or reduced motion → content just shows.
export function Reveal({ as = "div", className, delay = 0, children, }) {
    const ref = useRef(null);
    useEffect(() => {
        const el = ref.current;
        if (!el)
            return;
        if (typeof IntersectionObserver === "undefined") {
            el.classList.add("hiw-in");
            return;
        }
        const io = new IntersectionObserver((entries) => {
            for (const entry of entries) {
                if (entry.isIntersecting) {
                    el.classList.add("hiw-in");
                    io.disconnect();
                }
            }
        }, { threshold: 0.15, rootMargin: "0px 0px -8% 0px" });
        io.observe(el);
        return () => io.disconnect();
    }, []);
    const style = delay
        ? { transitionDelay: `${delay}ms` }
        : undefined;
    return createElement(as, { ref, className: cn("hiw-reveal", className), style }, children);
}
